/**
 * The research policy on `model_policy.research`. The develop loop that read it, and the `algorithms.*` rows it wrote,
 * went with lane BOO2 (research is the platform's research programs): the field is inert, kept so stored policies
 * still parse.
 */
import { z } from 'zod'

/**
 * `model_policy.research` (optional): the develop loop's budget and cadence for the agent. Plan-mode agents get the
 * loop scheduled; rules-only agents only run hypotheses their creator supplies.
 */
export const ResearchPolicy = z.object({
  /** Research credits per UTC day (micro); lowers the plan's allowance, never raises it. */
  maxSpendMicroPerDay: z.number().int().nonnegative().optional(),
  /** Seconds between scheduled hypotheses (plan mode; default 7 days). */
  intervalS: z.number().int().min(3600).optional(),
  /** Experiments (variants) per hypothesis (default 3, at most 6). */
  maxExperiments: z.number().int().min(1).max(6).optional(),
  /** Activate a promoted algorithm on a new version by itself (default true); false leaves it for the creator. */
  autoActivate: z.boolean().optional(),
})
export type ResearchPolicy = z.output<typeof ResearchPolicy>
